import { Link } from 'react-router-dom';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-gray-50 font-poppins">
      <Header />

      <div className="bg-gradient-to-r from-gold-50 to-amber-50 py-12">
        <div className="container mx-auto px-4">
          <nav className="text-sm text-gray-600 mb-4">
            <Link to="/" className="hover:text-gold-600 cursor-pointer">
              Anasayfa
            </Link>
            <span className="mx-2">/</span>
            <span className="text-gray-800 font-medium">Hakkımızda</span>
          </nav>
          <h1 className="text-4xl font-bold text-gray-800">Hakkımızda</h1>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Emin Kuyumculuk</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              1994 yılından bu yana altın sektöründe güvenilir hizmet veren Emin Kuyumculuk, 
              30 yıllık tecrübesi ile müşterilerine en kaliteli ürünleri sunmaktadır.
            </p>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Kapalıçarşı'daki köklü mağazamızdan başlayan yolculuğumuz, bugün online platformda 
              da devam etmektedir. Tüm ürünlerimiz resmi sertifikalı ve garantilidir.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Müşteri memnuniyeti odaklı çalışma prensibimiz ile güvenilir alışveriş deneyimi 
              sunmaya devam ediyoruz.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white rounded-lg shadow-sm p-6 text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gold-100 rounded-full mx-auto mb-4">
                <i className="ri-award-line text-3xl text-gold-600"></i>
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">30 Yıllık Tecrübe</h3>
              <p className="text-sm text-gray-600">
                Sektörde uzun yıllara dayanan deneyim ve güven
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-sm p-6 text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gold-100 rounded-full mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-gold-600"></i>
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">Sertifikalı Ürünler</h3>
              <p className="text-sm text-gray-600">
                Tüm ürünlerimiz resmi sertifikalı ve garantili
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-sm p-6 text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gold-100 rounded-full mx-auto mb-4">
                <i className="ri-customer-service-line text-3xl text-gold-600"></i>
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">Müşteri Memnuniyeti</h3>
              <p className="text-sm text-gray-600">
                7/24 müşteri hizmetleri desteği
              </p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Neden Emin Kuyumculuk?</h2>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <i className="ri-checkbox-circle-fill text-gold-600 text-xl mt-1"></i>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">Güvenilir Alışveriş</h3>
                  <p className="text-sm text-gray-600">
                    SSL ve 3D Secure ile korunan güvenli ödeme sistemi
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <i className="ri-checkbox-circle-fill text-gold-600 text-xl mt-1"></i>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">Ücretsiz Sigortalı Kargo</h3>
                  <p className="text-sm text-gray-600">
                    Tüm siparişlerinizde ücretsiz ve sigortalı teslimat
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <i className="ri-checkbox-circle-fill text-gold-600 text-xl mt-1"></i>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">Kolay İade</h3>
                  <p className="text-sm text-gray-600">
                    14 gün içinde koşulsuz iade garantisi
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <i className="ri-checkbox-circle-fill text-gold-600 text-xl mt-1"></i>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">Taksit İmkanı</h3>
                  <p className="text-sm text-gray-600">
                    12 aya varan taksit seçenekleri
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
